import { render, staticRenderFns } from "./PropertyForm.vue?vue&type=template&id=8ac182e4&scoped=true&"
import script from "./PropertyForm.vue?vue&type=script&lang=js&"
export * from "./PropertyForm.vue?vue&type=script&lang=js&"
import style0 from "./PropertyForm.vue?vue&type=style&index=0&id=8ac182e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac182e4",
  null
  
)

export default component.exports